import { Component, Inject, OnInit } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

// local application
import { IJsonResponseModel } from 'app/store/global/json-response.model';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  standalone: false,
})
export class SnackBarComponent implements OnInit {
  constructor(
    @Inject(MatSnackBarRef)
    public snackBarRef: MatSnackBarRef<SnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: Pick<IJsonResponseModel<[]>, 'success' | 'message'>
  ) {}

  ngOnInit(): void {}
}
